import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import classNames from 'classnames';
import styles from './assets/tabs.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
interface Props {
    tabs: { eventKey: string; title: string; renderComponent: any }[];
    activeTab: string | number;
    setTab: (k: string | null) => void;
}
const ControlledTabs: React.FC<Props> = ({ tabs, activeTab, setTab }: Props) => {
    const isMobile = window.innerWidth <= 800;
    const [opened, setOpened] = useState(isMobile ? false : true);

    return (
        <Tabs
            className={classNames(styles.tabs, opened ? 'opened' : '')}
            activeKey={activeTab}
            onSelect={(k) => {
                setTab(k);
                if (isMobile) {
                    if (k !== activeTab) {
                        setOpened(false);
                    }
                }
            }}
        >
            {tabs.map((it: any, ind: any) => {
                if (isMobile) {
                    return (
                        <Tab
                            tabClassName={!it.isHide || (it.isHide && it.eventKey === activeTab) ? '' : styles.dNone}
                            key={`tab-${ind}`}
                            eventKey={it.eventKey}
                            title={
                                <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                                    {it.title}
                                    {it.eventKey === activeTab ? (
                                        <div
                                            onClick={() => {
                                                setOpened(!opened);
                                            }}
                                            className={classNames(styles.tabDown)}
                                        >
                                            <FontAwesomeIcon icon={opened ? faChevronUp : faChevronDown} />
                                        </div>
                                    ) : null}
                                </div>
                            }
                        >
                            {it.eventKey === activeTab ? it.renderComponent : null}
                        </Tab>
                    );
                }
                return (
                    <Tab
                        tabClassName={it.isHide ? styles.dNone : ''}
                        key={`tab-${ind}`}
                        eventKey={it.eventKey}
                        title={
                            <div
                                className={`${
                                    it.eventKey === 'invoices' && activeTab === 'invoices-detail'
                                        ? styles.activeTab
                                        : ''
                                }`}
                                style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}
                            >
                                {it.title}
                            </div>
                        }
                    >
                        {it.eventKey === activeTab ? it.renderComponent : null}
                    </Tab>
                );
            })}
        </Tabs>
    );
};
export default ControlledTabs;
